import { createContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export const MultiContext = createContext();

export default function Context({ children }) {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState("generator");
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accounts, setAccounts] = useState(
    JSON.parse(localStorage.getItem("lockr-accounts")) || []
  );

  const addAccount = (e, name, username, password, url, thumbnail, notes) => {
    e.preventDefault();
    let account_ = {
      name: name,
      username: username,
      password: password,
      url: url,
      thumbnail: thumbnail,
      notes: notes,
      id: uuidv4(),
    };

    let accounts_ = [...accounts];
    accounts_.push(account_);

    setAccounts(accounts_);
  };

  const editAccount = (
    e,
    id,
    name,
    username,
    password,
    url,
    thumbnail,
    notes
  ) => {
    e.preventDefault();
    let accounts_ = [...accounts];
    let account_ = accounts_.find((x) => x.id === id);

    account_.name = name;
    account_.username = username;
    account_.password = password;
    account_.url = url;
    account_.thumbnail = thumbnail;
    account_.notes = notes;

    setAccounts(accounts_);
  };

  const deleteAccount = () => {
    let accounts_ = [...accounts].filter((x) => x.id !== selectedAccount?.id);
    setAccounts(accounts_);
  };

  useEffect(() => {
    localStorage.setItem("lockr-accounts", JSON.stringify(accounts));
  }, [accounts]);

  const contextValue = {
    loading: loading,
    setLoading: setLoading,

    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    selectedAccount: selectedAccount,
    setSelectedAccount: setSelectedAccount,

    accounts: accounts,
    setAccounts: setAccounts,

    addAccount: addAccount,
    editAccount: editAccount,
    deleteAccount: deleteAccount,
  };

  return (
    <MultiContext.Provider value={contextValue}>
      {children}
    </MultiContext.Provider>
  );
}
